import clsx from "classnames";
import classes from "./styles.module.scss";
import { decode } from "html-entities";

import Link from 'next/link';
export default function ResourceHero({ resource={}, className }) {

  return (
    <div className={clsx(className, classes.resource_hero)}>
      <img className={classes.resource_image} src={resource.image} alt="resource_image"></img>
      <div className={classes.content_cont}>
        <div className={classes.content}>
          <div className={classes.header}>
            <div className={classes.tag}>{resource.category}</div>
             {
                resource.minutes &&
                <div className={classes.duration}><img alt="read minutes" src="/icons/time-clock.png"></img>{`${resource.minutes} min read`}</div>
              }
          </div>

          <h4 className={classes.title}>{resource.title}</h4>
          <div className={classes.description}>
            <p>{decode(resource?.body).replace(/(<([^>]+)>)/ig, "").split(" ").splice(0,100).join(" ").concat("...")}</p>
          </div>
          <Link href={"/blog/" + resource.url_slug} passHref>
            <button className={classes.more_btn}>Read More<img src="/icons/arrow-right.png" alt="arrow-right"></img></button>
          </Link>
        </div>
      </div>
    </div>
  );
}

ResourceHero.defaultProps = {
  className: "",
};
